document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('SizeGuideDrawer');
  if (!drawer) return;

  const triggers = document.querySelectorAll('[data-size-guide-open]');
  const closers = drawer.querySelectorAll('[data-size-guide-close]');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('.size-guide-drawer__close')?.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  triggers.forEach(function (t) { t.addEventListener('click', open); });
  closers.forEach(function (c) { c.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
});
